import { type UserCounters } from '../models/user-counters';
import { type UserCountersDto } from '../dto/user-counters-dto';

export function mapUserCountersFromDto(dto: UserCountersDto): UserCounters {
  return {
    assignedMatters: dto.assigned_matters,
    uploadedDocuments: dto.uploaded_documents,
  };
}
